// extracted by mini-css-extract-plugin
module.exports = {"blockClick":"AudienceList_blockClick_3twhY"};